export class Preference {
    public boxedlayout: string;
    public collapse_menu: string;
    public fixedfooter: string;
    public fixednavbar1: string;
    public fixednavbar2: string;
    public fixedsidebar: string;
    public skin_type: string;
    public flatedesign:string;
}